import AWSAccountSubnet from './AWSAccountSubnet';

export default class AWSAccountConnectivityConfiguration {
	id!: number;

	region!: string;

	priority!: number;

	cidr!: string;

	route53ResolverRuleAssociations!: string;

	enableS3GatewayEndpoint!: boolean;

	tags!: { [key: string]: string };

	subnets!: AWSAccountSubnet[];

	constructor(obj: any) {
		Object.assign(this, obj);
		this.region = obj.region?.name;
		this.cidr = obj.cidr?.prefix + '/' + obj.cidr?.mask;
		this.tags = obj.tags;
		this.subnets = obj.subnets?.map((subnetObj: any) => new AWSAccountSubnet(subnetObj));
	}
}
